var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx } from "react/jsx-runtime";
import { mergeStyles } from "@fluentui/react/lib/Styling";
var StepLayouts = /* @__PURE__ */ ((StepLayouts2) => {
  StepLayouts2["default"] = "632px";
  StepLayouts2["fullWidth"] = "100%";
  return StepLayouts2;
})(StepLayouts || {});
const defaultClassName = "ane-StepContainer";
const StepContainer = (_a) => {
  var _b = _a, { className, children, layout = "632px" } = _b, rest = __objRest(_b, ["className", "children", "layout"]);
  return /* @__PURE__ */ jsx(
    "div",
    __spreadProps(__spreadValues({
      className: mergeStyles(
        `${defaultClassName}`,
        {
          maxWidth: layout,
          width: "100%"
        },
        className
      )
    }, rest), {
      children
    })
  );
};
export {
  StepContainer,
  StepLayouts
};
//# sourceMappingURL=StepContainer.js.map
